import React from 'react'
import { cm } from '~/utils/utils'

export type SelectorDropdownAlign = 'start' | 'end'

export interface SelectorDropdownContentProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Horizontal edge of the trigger to align the popover to. */
  align?: SelectorDropdownAlign
  /** Minimum width utility for the popover surface. */
  minWidthClassName?: string
}

export function SelectorDropdownContent({
  align = 'end',
  minWidthClassName = 'min-w-[220px]',
  className,
  style,
  children,
  ...props
}: SelectorDropdownContentProps) {
  return (
    <div
      className={cm(
        'absolute top-full mt-1 overflow-hidden rounded-2xl border border-tokens-neutral-border-2 bg-tokens-neutral-bg-white shadow-popover',
        align === 'end' ? 'right-0' : 'left-0',
        minWidthClassName,
        className
      )}
      style={{ zIndex: 1000000, ...style }}
      {...props}
    >
      {children}
    </div>
  )
}

export interface SelectorDropdownItemProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** Adds the standard divider below this item. */
  hasDivider?: boolean
}

export function SelectorDropdownItem({
  hasDivider = false,
  className,
  children,
  type = 'button',
  ...props
}: SelectorDropdownItemProps) {
  return (
    <button
      type={type}
      className={cm(
        'flex w-full items-center justify-between px-4 py-3 text-left transition-colors',
        'hover:bg-tokens-neutral-fill-fill-6 focus:bg-tokens-neutral-fill-fill-6 focus:outline-none',
        'disabled:pointer-events-none disabled:opacity-50',
        hasDivider && 'border-b border-tokens-neutral-border-2',
        className
      )}
      {...props}
    >
      {children}
    </button>
  )
}

export default SelectorDropdownContent
